


























































import { Component, Vue } from "vue-property-decorator";
import { Button, Field, Dialog, Loading, Toast,Empty } from "vant";
import {webViewRightButton} from "@/utils/hybirdMethods";
import _ from "lodash";
import { formatDate } from "@/utils/date";
import amountDisplay from "@/mixins/amountDisplay";

@Component({
  components: {
    [Button.name]: Button,
    [Field.name]: Field,
    [Dialog.Component.name]: Dialog.Component,
    [Loading.name]: Loading,
    [Empty.name]: Empty
  },
  mixins: [
    amountDisplay
  ],
})
export default class Transfer extends Vue {
  showDialog = false;
  dialogParmas = {
      password:'',
      // account_type:(this as any).$localstorage.get("userInfo").open_account_status
      account_type:''
  }
  listParmas = {
      page_size:10,page:1,account: "", account_type:""
  }
  curRow: any = {};
  isRead = false;
  recordList: any = [];
  noData = false;
  queryType = null;

  // get isSubmitDisabled() {
  //   return !this.form.amount;
  // }

  created() {
      // this.transferList()
    
      const { account, account_type } = (this as any).$route.query;
      (this as any).account = account;
      (this as any).account_type = account_type;
      this.initScroll()
      const query = `account=${account}&account_type=${account_type}`;
      webViewRightButton({"url":{"type":1,  "url":"/transfer-record" + query},"isDisplay":"false","title":""})
  }
  get bgColor() {
    return this.$store.getters["common/bgColor"];
  }
  get bgColorDialog(){
    return (this as any).bgColor != 'white-theme' ? 'black-theme-dialog' : ''
  }

  goforget(){
      // account_type = 1 期货(a_account) 2证券(b_account)  1表示a到b，2表示b到a
      let type = this.curRow.type === 1?'1':'2'
      this.$router.push({
          path:'/trade-password-reset',
          query: {
              type:type
          }
      })
  }
  cancelOrder(row:any={}){
    Dialog.confirm({
      ["message" as any]: this.$t("funds.transferRecord.domText[3]"),
      ["confirmButtonText" as any]: this.$t("funds.transferRecord.domText[8]"),
      ["cancelButtonText" as any]: this.$t("funds.transferRecord.domText[7]"),
      ["className" as any]:(this as any).bgColor == 'black-theme' ? 'black-theme-dialog' : '',
      confirmButtonColor:'#1989fa'
    })
      .then(() => {
        // this.curRow = row
        // if(row.type === 1){
        //     this.showDialog = true
        //     this.dialogParmas.account_type = row.type === 1?'1':'2'
        // }else{
        //     this.transferCancel()
        // }
        this.transferCancel(row)
      })
      .catch(() => {
        // on cancel
      });
  }
  transferList(){
    (this as any).listParmas.account =  (this as any).account;
    (this as any).listParmas.account_type =  (this as any).account_type;
      (this as any).$apis
      .transferList(this.listParmas, {customLoading: true})
      .then(res => {
        if (res) {
          if(res.data.length){
              this.recordList = [...this.recordList,...res.data]
          }else{
              this.noData = true
          }
        }
      })
      .catch(() => {
        // do catch
      });
  }
  verifyTradePassword(){
      if(!this.dialogParmas.password){
          Dialog.alert({
              ["title" as any]: this.$t("funds.transferRecord.domText[6]"),
              ["message" as any]: this.$t("funds.transferRecord.domText[4]"),
              ["className" as any]:(this as any).bgColor == 'black-theme' ? 'black-theme-dialog' : ''
          }).then(() => {
          // on close
          });
          return
      }

      (this as any).$apis
      .verifyTradePassword(this.dialogParmas)
      .then(() => {
          this.transferCancel()
      })
      .catch(e => {
          this.dialogParmas.password = ''
          
      });
  }
  transferCancel(row:any={}){
      (this as any).$apis
      .transferCancel({
          transfer_status:3,
          id:row.id
          // id:this.curRow.id
      }, {customLoading: true})
      .then(res => {
          if (res) {
              // let index = this.recordList.findIndex(item => item.id === this.curRow.id)
              let index = this.recordList.findIndex(item => item.id === row.id)
              this.recordList[index].transfer_status = 3
              let date = new Date()
              this.recordList[index].handler_at = formatDate(date, "yyyy-MM-dd hh:mm:ss");
              Dialog.alert({
                  ["title" as any]: this.$t("funds.transferRecord.domText[6]"),
                  ["message" as any]: this.$t("funds.transferRecord.domText[5]"),
                ["className" as any]:(this as any).bgColor == 'black-theme' ? 'black-theme-dialog' : ''
              }).then(() => {
              // on close
              });
          }
      })
      .catch(() => {
        // do catch
      });
  }
  initScroll(){
      this.isRead = false;
      this.transferList()
      this.$nextTick(() => {
          const box: any = document.getElementById("app");
          if(box.scrollTo){
              box.scrollTo(0,0)
          }else{
              box.scrollTop = 0
          }
          box.onscroll = null;
          let first = true;
          box.onscroll = _.throttle(() => {
              if((first && box.scrollTop > 0) || (this.$route.path !== location.pathname)){
                  if(box.scrollTo){
                      box.scrollTo(0,0)
                  }else{
                      box.scrollTop = 0
                  }
                  first = false
              }
              const clientHeight = box.clientHeight;
              const scrollTop = box.scrollTop;
              const scrollHeight = box.scrollHeight;
              if (scrollTop + clientHeight + 10 >= scrollHeight && !this.noData) {
                  this.isRead = true;
                  this.listParmas.page++
                  this.transferList()
              }
          }, 100);
      });
  }
}
